export default __webpack_public_path__ + "static/banner-10-outrageous-things-you-can-actually-have-at-your-wedding-2e8ee2da5c001ed03fb9f844970c96ab.jpg";